import { SelectNavigation } from "./SelectNavigation";
import { AdvancedViewOptions } from "./AdvancedViewOptions";
import { select } from "@wordpress/data";
import { STORE_NAME } from "../store";
import { Breadcrumbs } from "./Breadcrumbs";
import { useEffect, useState } from "@wordpress/element";
import { VerseAutocomplete } from "./VerseAutocomplete";

export const TopBar = () => {
	const [isSticky, setIsSticky] = useState(false);
	const [lastScrollY, setLastScrollY] = useState(0);

	useEffect(() => {
		const handleScroll = () => {
			const currentScrollY = window.scrollY;

			if (currentScrollY < lastScrollY) {
				// Scrolling up
				setIsSticky(true);
			} else {
				// Scrolling down
				setIsSticky(false);
			}

			setLastScrollY(currentScrollY);
		};

		window.addEventListener("scroll", handleScroll);
		return () => {
			window.removeEventListener("scroll", handleScroll);
		};
	}, [lastScrollY]);

	const chapters = select(STORE_NAME).getChapters();
	const pageType = select(STORE_NAME).getPageType();
	const verses = select(STORE_NAME).getVerses();

	return (
		<div
			className={`${
				isSticky ? "sticky top-0" : "relative"
			} bg-white py-4 border-grey-200 border-b border-gray-200 border-solid`}
		>
			<Breadcrumbs />

			<div className="flex flex-wrap lg:gap-2 gap-3 mt-4">
				{pageType !== "book" && (
					<SelectNavigation
						options={chapters}
						label="בחירת פרק להצגה"
						key="chapter"
					/>
				)}
				{pageType === "chapter" && verses.length > 1 && 
					<AdvancedViewOptions />	
				}
				<VerseAutocomplete />
			</div>
		</div>
	);
};